import React from "react";
import { Step as Stepper } from "semantic-ui-react";

interface Props {
  trial: boolean
  activeLifecycle: server.dto.ClientOnboardingLifeCycles
  sessionLifecycle: server.dto.ClientOnboardingLifeCycles
  onLifecycleChanged: (newLifecycle: server.dto.ClientOnboardingLifeCycles) => void
}

const Steps = (props: Props) => {
  const steps = props.trial ? stepsForTrial : stepsForPaid;

  return <Stepper.Group fluid>
    {steps.map(step => (
      <Stepper
        key={step.lifecycle}
        active={props.activeLifecycle === step.lifecycle}
        disabled={!canAccess(props.sessionLifecycle, step.lifecycle)}
        onClick={() => { props.onLifecycleChanged(step.lifecycle); }}
        completed={hasCompleted(props.sessionLifecycle, step.lifecycle)}
      >
        <Stepper.Content>
          <Stepper.Title>{step.label}</Stepper.Title>
        </Stepper.Content>
      </Stepper>
    ))}
  </Stepper.Group>;
};

const stepsForTrial: Array<{ lifecycle: server.dto.ClientOnboardingLifeCycles, label: string }> = [
  { lifecycle: "setYourDetails", label: "Provide your details" },
  { lifecycle: "configureSubscription", label: "Terms & conditions" },
  { lifecycle: "readyForCreateClientAccount", label: "Done" }
];

const stepsForPaid: Array<{ lifecycle: server.dto.ClientOnboardingLifeCycles, label: string }> = [
  { lifecycle: "setYourDetails", label: "Provide your details" },
  { lifecycle: "configureSubscription", label: "Choose your plan" },
  { lifecycle: "paymentSetup", label: "Set payment method" },
  { lifecycle: "readyForCreateClientAccount", label: "Done" }
];

const lifeCycleRank: server.dto.ClientOnboardingLifeCycles[] = [
  "setYourDetails",
  "configureSubscription",
  "paymentSetup",
  "readyForCreateClientAccount"
];

const hasCompleted = (sessionLifecycle: server.dto.ClientOnboardingLifeCycles, lifecycle: server.dto.ClientOnboardingLifeCycles) => {
  return lifeCycleRank.indexOf(sessionLifecycle) > lifeCycleRank.indexOf(lifecycle);
};

const canAccess = (sessionLifecycle: server.dto.ClientOnboardingLifeCycles, lifeCycleToCheck: server.dto.ClientOnboardingLifeCycles) => {
  if (sessionLifecycle === "readyForCreateClientAccount" || sessionLifecycle === "clientAccountCreated") { return false; }

  return lifeCycleRank.indexOf(sessionLifecycle) >= lifeCycleRank.indexOf(lifeCycleToCheck);
};
export default Steps;